var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mg-less color-gray text-font-14"},[_vm._v(" Yes You Can © 2021 ")])}
var staticRenderFns = []

export { render, staticRenderFns }